import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { InformacionPacienteModel } from '../../models/informacion-paciente.model';
import { Client, RespuestaExtendedDto, RespuestaFlatDto, RespuestaPreguntaDto } from '../../services/client';

@Component({
	selector: 'app-informacion-paciente',
	templateUrl: './informacion-paciente.component.html'
})
export class InformacionPacienteComponent {

	@Input() readonly = false;
	@Input() datosEncuestado: InformacionPacienteModel = new InformacionPacienteModel();
	@Input() pacienteForm: FormGroup = new FormGroup({});
	@Output() changed: EventEmitter<InformacionPacienteModel> = new EventEmitter<InformacionPacienteModel>();
	validDate = undefined;
	constructor(public router: Router, public client: Client, private alertService: AlertService) {
		const pacienteForm = new InformacionPacienteModel({});
		this.pacienteForm = pacienteForm.getFormGroup();
	}

	changeValue(value, name) {
		this.datosEncuestado[name] = value;
		this.validDate = this.datosEncuestado.fechaNacimiento === undefined ? undefined : !!this.datosEncuestado.fechaNacimiento;
		this.changed.emit(this.datosEncuestado);
	}
}
